import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  MdOutlineDashboard,
  MdAccountTree,
} from "react-icons/md";
import { FaUserGraduate, FaSignOutAlt } from "react-icons/fa";
import logo from "../Assets/dbskills-logo.webp";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const role = localStorage.getItem("role"); // 👈 LOAD ROLE
  const [activeButton, setActiveButton] = useState(
    localStorage.getItem("activeButton") || "Dashboard"
  );

  const menuItems = [
    {
      name: "Dashboard",
      href: "/dash",
      icon: <MdOutlineDashboard />,
      roles: ["admin", "branchUser"],
    },
    {
      name: "Centers",
      href: "/branches",
      icon: <MdAccountTree />,
      roles: ["admin"],  // 👈 ONLY ADMIN
    },
    {
      name: "Candidates",
      href: "/candidates",
      icon: <FaUserGraduate />,
      roles: ["admin", "branchUser"],
    },
     {
      name: "Activity Logs",
      href: "/logs",
      icon: <FaUserGraduate />,
      roles: ["admin"],
    },
  ];

  useEffect(() => {
    const handleResize = () => setIsSidebarOpen(window.innerWidth >= 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIsSidebarOpen]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const currentItem = menuItems.find((item) => item.href === currentPath);
    if (currentItem) {
      setActiveButton(currentItem.name);
      localStorage.setItem("activeButton", currentItem.name);
    }
  }, [location.pathname]);

  return (
    <>
      <div
        className={`fixed top-0 left-0 z-50 h-screen overflow-y-auto bg-white shadow-2xl w-64
        transition-transform duration-300 
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}
      >
        <div className="p-6 flex justify-center border-b">
          <Link to="/" className="flex justify-center">
            <img src={logo} alt="Logo" className="w-28 h-auto" />
          </Link>
        </div>

        <ul className="px-5 mt-6 space-y-2">

          {/* Role-based menu */}
          {menuItems
            .filter(item => item.roles.includes(role))  // ✔ ROLE FILTER
            .map((item) => {
              const isActive = activeButton === item.name;

              return (
                <li key={item.name}>
                  <button
                    className={`flex items-center p-3 w-full rounded-lg space-x-3 font-medium transition-all
                      ${
                        isActive
                          ? "bg-[#2BB5CE] text-white shadow-md"
                          : "text-gray-700 hover:bg-[#2BB5CE]/10 hover:text-[#2BB5CE]"
                      }`}
                    onClick={() => {
                      setActiveButton(item.name);
                      localStorage.setItem("activeButton", item.name);
                      setIsSidebarOpen(false);
                      navigate(item.href);
                    }}
                  >
                    <span className="text-2xl">{item.icon}</span>
                    <span>{item.name}</span>
                  </button>
                </li>
              );
            })}

          <li className="mt-8">
            <button
              onClick={handleLogout}
              className="flex items-center space-x-3 w-full p-3 rounded-lg text-gray-700 hover:bg-red-500 hover:text-white transition-colors"
            >
              <FaSignOutAlt className="text-xl" />
              <span className="font-medium">Logout</span>
            </button>
          </li>

        </ul>
      </div>

      {isSidebarOpen && (
        <div
          onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 z-10 bg-black bg-opacity-40 lg:hidden"
        />
      )}
    </>
  );
};

export default Sidebar;
